<template>
	<div class="common-Echarts-CustomGauge">
		<div :id="'CustomGaugeMian'+num" ref="CustomGaugeMian" style="height: 250px;"></div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			num: {
				type: Number,
				default: 1
			},
			valueObject: {
				type: Object,
				default: () => {
					return {

					}
				}
			}
		},
		data() {
			return {
				insidePanelRadius: 60, //圆心
				pointerInnerRadius: 40,
				outerRadius: 120, //旋转圆
				innerRadius: 150, //旋转圆圆心距离
				currentDataIndex: 0,
				// valOnRadianMax: this.valueObject.YearRatio, //最大百分比
				valueObjectData: {},
				animationEasingUpdate: 'quarticInOut',
				animationDurationUpdate: 1000,
				animationDuration: 1000, //旋转动画时间 http://60.191.17.178:9003/upload/picture/redcircle.png?NodeID=64
				panelImageURL: 'http://60.191.17.178:9003/upload/picture/redcircle.png?NodeID=64',
			}
		},
		created() {},
		mounted() {},
		activated() {},
		updated() {},
		methods: {
			convertToPolarPoint(renderItemParams, radius, radian) {
				return [
					Math.cos(radian) * radius + renderItemParams.coordSys.cx,
					-Math.sin(radian) * radius + renderItemParams.coordSys.cy
				];
			},
			makePionterPoints(renderItemParams, polarEndRadian) {
				return [
					this.convertToPolarPoint(renderItemParams, this.outerRadius, polarEndRadian),
					this.convertToPolarPoint(
						renderItemParams,
						this.outerRadius,
						polarEndRadian + Math.PI * 0.03
					),
					this.convertToPolarPoint(renderItemParams, this.pointerInnerRadius, polarEndRadian)
				];
			},
			makeText(valOnRadian) {
				// Validate additive animation calc.
				if (valOnRadian < -10) {
					alert('illegal during val: ' + valOnRadian);
				}
				return ((valOnRadian / this.valueObjectData.YearMaxRatio) * 100).toFixed(0) + '%';
			},
			renderItem(params, api) {
				var valOnRadian = api.value(1);
				var coords = api.coord([api.value(0), valOnRadian]);
				var polarEndRadian = coords[3];
				console.log(params, api);
				var _this = this
				var imageStyle = {
					image: _this.panelImageURL,
					x: params.coordSys.cx - this.outerRadius,
					y: params.coordSys.cy - this.outerRadius,
					width: _this.outerRadius * 2,
					height: _this.outerRadius * 2
				};
				return {
					type: 'group',
					children: [{
							type: 'image',
							style: imageStyle,
							clipPath: {
								type: 'sector',
								shape: {
									cx: params.coordSys.cx,
									cy: params.coordSys.cy,
									r: _this.outerRadius - 30,
									r0: _this.innerRadius,
									startAngle: 0,
									endAngle: -polarEndRadian,
									transition: 'endAngle',
									enterFrom: {
										endAngle: 0
									}
								}
							}
						},
						{
							type: 'image',
							style: imageStyle,
							clipPath: {
								type: 'polygon',
								shape: {
									points: _this.makePionterPoints(params, polarEndRadian)
								},
								extra: {
									polarEndRadian: polarEndRadian,
									transition: 'polarEndRadian',
									enterFrom: {
										polarEndRadian: 0
									}
								},
								during: function(apiDuring) {
									apiDuring.setShape(
										'points',
										_this.makePionterPoints(params, apiDuring.getExtra('polarEndRadian'))
									);
								}
							}
						},
						{
							type: 'circle',
							shape: {
								cx: params.coordSys.cx,
								cy: params.coordSys.cy,
								r: _this.insidePanelRadius
							},
							style: {
								fill: '#fff',
								shadowBlur: 25,
								shadowOffsetX: 0,
								shadowOffsetY: 0,
								shadowColor: 'rgba(0,0,0,0.0400)'
							}
						},
						{
							type: 'text',
							extra: {
								valOnRadian: valOnRadian,
								transition: 'valOnRadian',
								enterFrom: {
									valOnRadian: 0
								}
							},
							style: {
								text: _this.makeText(valOnRadian),
								fontSize: 40,
								fontWeight: 700,
								x: params.coordSys.cx,
								y: params.coordSys.cy,
								fill: '#E65068',
								align: 'center',
								verticalAlign: 'middle',
								enterFrom: {
									opacity: 0
								}
							},
							during: function(apiDuring) {
								apiDuring.setStyle(
									'text',
									_this.makeText(apiDuring.getExtra('valOnRadian'))
								);
							}
						}
					]
				}
			},

			OptionFunction() {
				let myChart = this.$MyEcharts.init(document.getElementById('CustomGaugeMian' + this.num));
				let option = {
					animationEasing: this.animationEasingUpdate,
					animationDuration: this.animationDuration,
					animationDurationUpdate: this.animationDurationUpdate,
					animationEasingUpdate: this.animationEasingUpdate,
					dataset: {
						source: [
							[1, this.valueObjectData.YearRatio]
						]
					},
					tooltip: {
						show: false
					},
					angleAxis: {
						type: 'value',
						startAngle: 0,
						show: false,
						min: 0,
						max: this.valueObjectData.YearRatio
					},
					radiusAxis: {
						type: 'value',
						show: false
					},
					polar: {},
					series: [{
						type: 'custom',
						coordinateSystem: 'polar',
						renderItem: this.renderItem,

					}]
				};
				//   setInterval(function () {
				//     var nextSource = [[1, Math.round(Math.random() * this.valOnRadianMax)]];
				//     myChart.setOption({
				//       dataset: {
				//         source: nextSource
				//       }
				//     });
				//   }, 3000);
				myChart.clear();
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			}
		},
		computed: {
			valOnRadianMax() {
				return this.valueObjectData.YearRatio
			},
		},
		watch: {
			valueObject: {
				handler(NewVal, OldVal) {
					if (NewVal) {
						console.log(NewVal);
						this.valueObjectData = NewVal
						this.OptionFunction()
					}
				},
				deep: true,
				immediate: true
			}
		},
	}
</script>
<style scoped lang='less'>
</style>
